import { render, staticRenderFns } from "./ProveedoresUpdate.vue?vue&type=template&id=a35bc880&"
import script from "./ProveedoresUpdate.vue?vue&type=script&lang=js&"
export * from "./ProveedoresUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports